module.exports = __webpack_public_path__ + "img/728-7a70e5.png";